/*!
 * Portal presets (KMZ action presets based on DJI samples)
 */
const PORTAL_PRESETS = {
    options: {},
    limits: {},
    docs: {},
    actions: { kml: [], kmz: [] },
    defaults: {
      kmzDroneProfile: '77:1',
      valueByPath: {},
      valueByField: {}
    },
    altitudeRules: {}
  }

  PORTAL_PRESETS.options.templateHeightModePresets = [
    { value: 'relativeToStartPoint', tooltip: 'preset.height_mode.relative_to_start_point' },
    { value: 'EGM96', tooltip: 'preset.height_mode.egm96', default: true },
    { value: 'realTimeFollowSurface', tooltip: 'preset.height_mode.real_time_follow_surface' }
  ]

  PORTAL_PRESETS.options.executeHeightModePresets = [
    { value: 'relativeToStartPoint', tooltip: 'preset.height_mode.relative_to_start_point' },
    { value: 'WGS84', tooltip: 'preset.height_mode.wgs84', default: true },
    { value: 'realTimeFollowSurface', tooltip: 'preset.height_mode.real_time_follow_surface' }
  ]

  PORTAL_PRESETS.options.djiDronePresets = [
    { value: '89', label: 'M350 RTK', tooltip: 'droneEnumValue=89', droneEnumValue: '89', droneSubEnumValue: '' },
    { value: '60', label: 'M300 RTK', tooltip: 'droneEnumValue=60', droneEnumValue: '60', droneSubEnumValue: '' },
    { value: '67:0', label: 'M30', tooltip: 'droneEnumValue=67, droneSubEnumValue=0', droneEnumValue: '67', droneSubEnumValue: '0' },
    { value: '67:1', label: 'M30T', tooltip: 'droneEnumValue=67, droneSubEnumValue=1', droneEnumValue: '67', droneSubEnumValue: '1' },
    { value: '77:0', label: 'M3E', tooltip: 'droneEnumValue=77, droneSubEnumValue=0', droneEnumValue: '77', droneSubEnumValue: '0' },
    { value: '77:1', label: 'M3T', tooltip: 'droneEnumValue=77, droneSubEnumValue=1', droneEnumValue: '77', droneSubEnumValue: '1', default: true },
    { value: '77:2', label: 'M3M', tooltip: 'droneEnumValue=77, droneSubEnumValue=2', droneEnumValue: '77', droneSubEnumValue: '2' },
    { value: '91:0', label: 'M3D', tooltip: 'droneEnumValue=91, droneSubEnumValue=0', droneEnumValue: '91', droneSubEnumValue: '0' },
    { value: '91:1', label: 'M3TD', tooltip: 'droneEnumValue=91, droneSubEnumValue=1', droneEnumValue: '91', droneSubEnumValue: '1' }
  ]

  PORTAL_PRESETS.options.djiDroneEnumPresets = [
    { value: '60', label: '60 (M300 RTK)', tooltip: 'preset.drone_enum.60' },
    { value: '67', label: '67 (M30/M30T)', tooltip: 'preset.drone_enum.67' },
    { value: '77', label: '77 (M3E/M3T/M3M)', tooltip: 'preset.drone_enum.77', default: true },
    { value: '89', label: '89 (M350 RTK)', tooltip: 'preset.drone_enum.89' },
    { value: '91', label: '91 (M3D/M3TD)', tooltip: 'preset.drone_enum.91' }
  ]

  PORTAL_PRESETS.options.djiDroneSubPresets = [
    { value: '0', label: '0', tooltip: 'preset.drone_sub.0' },
    { value: '1', label: '1', tooltip: 'preset.drone_sub.1', default: true },
    { value: '2', label: '2', tooltip: 'preset.drone_sub.2' }
  ]

  PORTAL_PRESETS.options.finishActionPresets = [
    { value: 'goHome', tooltip: 'preset.finish_action.go_home', default: true },
    { value: 'noAction', tooltip: 'preset.finish_action.no_action' },
    { value: 'autoLand', tooltip: 'preset.finish_action.auto_land' },
    { value: 'gotoFirstWaypoint', tooltip: 'preset.finish_action.goto_first_waypoint' }
  ]

  PORTAL_PRESETS.options.flyToWaylineModePresets = [
    { value: 'safely', tooltip: 'preset.fly_to_wayline_mode.safely', default: true },
    { value: 'pointToPoint', tooltip: 'preset.fly_to_wayline_mode.point_to_point' }
  ]

  PORTAL_PRESETS.options.globalWaypointHeadingModePresets = [
    { value: 'followWayline', tooltip: 'preset.waypoint_heading_mode.follow_wayline' },
    { value: 'manually', tooltip: 'preset.waypoint_heading_mode.manually', default: true },
    { value: 'fixed', tooltip: 'preset.waypoint_heading_mode.fixed' },
    { value: 'smoothTransition', tooltip: 'preset.waypoint_heading_mode.smooth_transition' }
  ]

  PORTAL_PRESETS.options.waypointHeadingModePresets = [
    { value: 'followWayline', tooltip: 'preset.waypoint_heading_mode.follow_wayline' },
    { value: 'manually', tooltip: 'preset.waypoint_heading_mode.manually' },
    { value: 'fixed', tooltip: 'preset.waypoint_heading_mode.fixed' },
    { value: 'smoothTransition', tooltip: 'preset.waypoint_heading_mode.smooth_transition', default: true }
  ]

  PORTAL_PRESETS.options.waypointHeadingPathModePresets = [
    { value: 'followBadArc', tooltip: 'preset.waypoint_heading_path_mode.follow_bad_arc', default: true },
    { value: 'clockwise', tooltip: 'preset.waypoint_heading_path_mode.clockwise' },
    { value: 'counterClockwise', tooltip: 'preset.waypoint_heading_path_mode.counter_clockwise' }
  ]

  PORTAL_PRESETS.options.gimbalPitchModePresets = [
    { value: 'manual', tooltip: 'preset.gimbal_pitch_mode.manual' },
    { value: 'usePointSetting', tooltip: 'preset.gimbal_pitch_mode.use_point_setting', default: true }
  ]

  PORTAL_PRESETS.options.waypointTurnModePresets = [
    { value: 'toPointAndStopWithDiscontinuityCurvature', tooltip: 'preset.waypoint_turn_mode.to_point_stop_discontinuity', default: true },
    { value: 'toPointAndStopWithContinuityCurvature', tooltip: 'preset.waypoint_turn_mode.to_point_stop_continuity' },
    { value: 'toPointAndPassWithContinuityCurvature', tooltip: 'preset.waypoint_turn_mode.to_point_pass_continuity' },
    { value: 'coordinateTurn', tooltip: 'preset.waypoint_turn_mode.coordinate_turn' }
  ]

  PORTAL_PRESETS.options.actionGroupModePresets = [
    { value: 'sequence', tooltip: 'preset.action_group_mode.sequence', default: true }
  ]

  PORTAL_PRESETS.options.actionTriggerTypePresets = [
    { value: 'reachPoint', tooltip: 'preset.action_trigger_type.reach_point', default: true },
    { value: 'betweenAdjacentPoints', tooltip: 'preset.action_trigger_type.between_adjacent_points' },
    { value: 'multipleTiming', tooltip: 'preset.action_trigger_type.multiple_timing' }
  ]

  PORTAL_PRESETS.options.executeRCLostActionPresets = [
    { value: 'goBack', tooltip: 'preset.execute_rc_lost_action.go_back', default: true }
  ]

  PORTAL_PRESETS.options.exitOnRCLostPresets = [
    { value: 'executeLostAction', tooltip: 'preset.exit_on_rc_lost.execute_lost_action', default: true }
  ]

  PORTAL_PRESETS.limits.kmzResearched = {
    rotateYaw: {
      aircraftHeading: { min: -180, max: 180 }
    },
    orientedShoot: {
      aircraftHeading: { min: -180, max: 180 },
      gimbalYawRotateAngle: { min: -180, max: 180 },
      gimbalPitchRotateAngle: {
        min: -120,
        max: 45,
        droneRanges: {
          '67': { min: -120, max: 45, label: 'M30/M30T' },
          '77': { min: -90, max: 35, label: 'M3E/M3T' },
          '91': { min: -90, max: 30, label: 'M3D/M3TD' }
        }
      }
    },
    accurateShoot: {
      aircraftHeading: { min: -180, max: 180 },
      gimbalYawRotateAngle: { min: -180, max: 180 }
    }
  }

  const valuePresetsByPath = {
    'Point.altitudeMode': [
      { value: 'absolute', tooltip: 'preset.altitude_mode.absolute' },
      { value: 'relativeToGround', tooltip: 'preset.altitude_mode.relative_to_ground', default: true },
      { value: 'clampToGround', tooltip: 'preset.altitude_mode.clamp_to_ground' }
    ],
    'template.Folder.waylineCoordinateSysParam.heightMode': PORTAL_PRESETS.options.templateHeightModePresets,
    'waylines.Folder.executeHeightMode': PORTAL_PRESETS.options.executeHeightModePresets,
    'globalWaypointHeadingParam.waypointHeadingMode': PORTAL_PRESETS.options.globalWaypointHeadingModePresets,
    'Folder.globalWaypointHeadingParam.waypointHeadingMode': PORTAL_PRESETS.options.globalWaypointHeadingModePresets,
    'waypointHeadingParam.waypointHeadingMode': PORTAL_PRESETS.options.waypointHeadingModePresets,
    'wpml:gimbalPitchMode': PORTAL_PRESETS.options.gimbalPitchModePresets,
    'Folder.gimbalPitchMode': PORTAL_PRESETS.options.gimbalPitchModePresets
  }
  PORTAL_PRESETS.valuePresetsByPath = valuePresetsByPath

  const valuePresetsByField = {
    altitudeMode: valuePresetsByPath['Point.altitudeMode'],
    heightMode: valuePresetsByPath['template.Folder.waylineCoordinateSysParam.heightMode'],
    executeHeightMode: valuePresetsByPath['waylines.Folder.executeHeightMode'],
    finishAction: PORTAL_PRESETS.options.finishActionPresets,
    flyToWaylineMode: PORTAL_PRESETS.options.flyToWaylineModePresets,
    waypointHeadingPathMode: PORTAL_PRESETS.options.waypointHeadingPathModePresets,
    waypointTurnMode: PORTAL_PRESETS.options.waypointTurnModePresets,
    actionGroupMode: PORTAL_PRESETS.options.actionGroupModePresets,
    actionTriggerType: PORTAL_PRESETS.options.actionTriggerTypePresets,
    executeRCLostAction: PORTAL_PRESETS.options.executeRCLostActionPresets,
    exitOnRCLost: PORTAL_PRESETS.options.exitOnRCLostPresets,
    droneEnumValue: PORTAL_PRESETS.options.djiDroneEnumPresets,
    droneSubEnumValue: PORTAL_PRESETS.options.djiDroneSubPresets,
    waypointHeadingAngleEnable: null,
    globalUseStraightLine: null,
    useGlobalHeight: null,
    useGlobalSpeed: null,
    useGlobalHeadingParam: null,
    useGlobalTurnParam: null,
    useStraightLine: null,
    isRisky: null,
    caliFlightEnable: null,
    dewarpingEnable: null,
    modelColoringEnable: null
  }
  PORTAL_PRESETS.valuePresetsByField = valuePresetsByField

  PORTAL_PRESETS.runtime = {}
  const fieldHelpDetailsByField = PORTAL_PRESETS.runtime.fieldHelpDetailsByField = {}
  const valueHelpByPath = PORTAL_PRESETS.runtime.valueHelpByPath = {}
  const valueHelpByField = PORTAL_PRESETS.runtime.valueHelpByField = {}
  const fieldTooltipsByPath = PORTAL_PRESETS.runtime.fieldTooltipsByPath = {}
  const fieldTooltipsByField = PORTAL_PRESETS.runtime.fieldTooltipsByField = {}
  const fieldIconsByPath = PORTAL_PRESETS.runtime.fieldIconsByPath = {}
  const fieldIconsByField = PORTAL_PRESETS.runtime.fieldIconsByField = {}
  const fieldRequiredByPath = PORTAL_PRESETS.runtime.fieldRequiredByPath = {}
  const fieldRequiredByField = PORTAL_PRESETS.runtime.fieldRequiredByField = {}
  const fieldDisableRules = PORTAL_PRESETS.runtime.fieldDisableRules = []

  PORTAL_PRESETS.options.boolPreset = [
    { value: '0', label: '0', tooltip: 'preset.bool.off_false' },
    { value: '1', label: '1', tooltip: 'preset.bool.on_true' }
  ]

  PORTAL_PRESETS.options.boolPresetZeroDefault = [
    { value: '0', label: '0', tooltip: 'preset.bool.off_false', default: true },
    { value: '1', label: '1', tooltip: 'preset.bool.on_true' }
  ]

  PORTAL_PRESETS.options.boolPresetOneDefault = [
    { value: '0', label: '0', tooltip: 'preset.bool.off_false' },
    { value: '1', label: '1', tooltip: 'preset.bool.on_true', default: true }
  ]

  valuePresetsByField.waypointHeadingAngleEnable = PORTAL_PRESETS.options.boolPresetOneDefault
  valuePresetsByField.globalUseStraightLine = PORTAL_PRESETS.options.boolPresetOneDefault
  valuePresetsByField.useGlobalHeight = PORTAL_PRESETS.options.boolPresetZeroDefault
  valuePresetsByField.useGlobalSpeed = PORTAL_PRESETS.options.boolPresetOneDefault
  valuePresetsByField.useGlobalHeadingParam = PORTAL_PRESETS.options.boolPresetZeroDefault
  valuePresetsByField.useGlobalTurnParam = PORTAL_PRESETS.options.boolPresetOneDefault
  valuePresetsByField.useStraightLine = PORTAL_PRESETS.options.boolPresetOneDefault
  valuePresetsByField.isRisky = PORTAL_PRESETS.options.boolPresetZeroDefault
  valuePresetsByField.caliFlightEnable = PORTAL_PRESETS.options.boolPresetZeroDefault
  valuePresetsByField.dewarpingEnable = PORTAL_PRESETS.options.boolPresetZeroDefault
  valuePresetsByField.modelColoringEnable = PORTAL_PRESETS.options.boolPresetZeroDefault

  PORTAL_PRESETS.options.boolLikeFields = [
    'useGlobalHeight',
    'useGlobalSpeed',
    'useGlobalHeadingParam',
    'useGlobalTurnParam',
    'isRisky',
    'isPointFocus',
    'isInfiniteFocus',
    'isCalibrationFocus',
    'useGlobalPayloadLensIndex',
    'isUseFocalFactor'
  ]

  PORTAL_PRESETS.options.boolLikeFields.forEach((field) => {
    if (!valuePresetsByField[field]) {
      valuePresetsByField[field] = PORTAL_PRESETS.options.boolPreset
    }
  })

  const defaultValueByPath = PORTAL_PRESETS.defaults.valueByPath
  const defaultValueByField = PORTAL_PRESETS.defaults.valueByField
  const stripNamespacePrefixes = function (path) {
    return String(path || '').split('.').map((part) => String(part || '').replace(/^[a-zA-Z_][\w-]*:/, '')).join('.')
  }
  const stripLeadingScope = function (path) {
    return String(path || '').replace(/^(template|waylines)\./, '')
  }
  const stripNumericParts = function (path) {
    return String(path || '').split('.').filter((part) => !/^\d+$/.test(String(part || ''))).join('.')
  }
  const getPathLeafField = function (path) {
    const parts = String(path || '').split('.').filter((part) => {
      const text = String(part || '').trim()
      return !!text && text !== '@param' && text !== '_text'
    })
    return parts.length ? parts[parts.length - 1] : ''
  }
  const getDefaultPresetValue = function (presets) {
    const list = Array.isArray(presets) ? presets : []
    const match = list.find((entry) => entry && entry.default === true && entry.value !== undefined && entry.value !== null)
    return match ? String(match.value).trim() : ''
  }
  const assignDefaultPresetValues = function (target, sourceMap) {
    Object.keys(sourceMap || {}).forEach((key) => {
      const defaultValue = getDefaultPresetValue(sourceMap[key])
      if (!defaultValue) return
      target[String(key)] = defaultValue
    })
  }
  assignDefaultPresetValues(defaultValueByPath, valuePresetsByPath)
  assignDefaultPresetValues(defaultValueByField, valuePresetsByField)

  Object.assign(defaultValueByField, {
    takeOffSecurityHeight: '20',
    globalTransitionalSpeed: '15',
    waylineAvoidLimitAreaMode: '0',
    payloadEnumValue: '67',
    payloadSubEnumValue: '0',
    payloadPositionIndex: '0',
    templateType: 'waypoint',
    coordinateMode: 'WGS84',
    positioningType: 'GPS',
    autoFlightSpeed: '5',
    globalHeight: '42',
    waypointHeadingAngle: '0',
    waypointPoiPoint: '0.000000,0.000000,0.000000',
    waypointHeadingPoiIndex: '0',
    meteringMode: 'average',
    returnMode: 'singleReturnStrongest',
    samplingRate: '240000',
    scanningMode: 'nonRepetitive',
    ellipsoidHeight: '42',
    height: '42',
    gimbalPitchAngle: '0',
    waypointSpeed: '5',
    waypointTurnDampingDist: '0',
    waypointGimbalPitchAngle: '0',
    waypointGimbalYawAngle: '0',
    waypointWorkType: '0'
  })

  const buildDefaultPathVariants = function (path) {
    const raw = String(path || '').trim()
    const rawNoNs = stripNamespacePrefixes(raw)
    const noScope = stripLeadingScope(rawNoNs)
    const noNums = stripNumericParts(rawNoNs)
    const noScopeNoNums = stripNumericParts(noScope)
    return [raw, rawNoNs, noScope, noNums, noScopeNoNums].filter(Boolean).filter((value, idx, arr) => arr.indexOf(value) === idx)
  }

  const resolvePortalPresetDefaultValue = function (path) {
    const variants = buildDefaultPathVariants(path)
    for (let i = 0; i < variants.length; i += 1) {
      const candidate = variants[i]
      if (Object.prototype.hasOwnProperty.call(defaultValueByPath, candidate)) {
        return defaultValueByPath[candidate]
      }
    }
    const leafField = getPathLeafField(stripLeadingScope(stripNamespacePrefixes(path)))
    if (leafField && Object.prototype.hasOwnProperty.call(defaultValueByField, leafField)) {
      return defaultValueByField[leafField]
    }
    return undefined
  }

  const applyPortalPresetDefaultsToFlatMap = function (map) {
    const source = (map && typeof map === 'object') ? map : {}
    const out = Object.assign({}, source)
    Object.keys(out).forEach((path) => {
      const presetDefaultValue = resolvePortalPresetDefaultValue(path)
      if (presetDefaultValue === undefined) return
      out[path] = presetDefaultValue
    })
    return out
  }

  PORTAL_PRESETS.docs.fields = {
    createTime: { icon: 'fa-regular fa-calendar-plus' },
    updateTime: { icon: 'fa-regular fa-clock' },
    globalUseStraightLine: { icon: 'fa-solid fa-route' },
    heightMode: { icon: 'fa-solid fa-mountain-city' },
    executeHeightMode: { icon: 'fa-solid fa-mountain-sun' },
    globalHeight: { icon: 'fa-solid fa-ruler-vertical' },
    ellipsoidHeight: { icon: 'fa-solid fa-earth-europe' },
    height: { icon: 'fa-solid fa-arrow-up-long' },
    executeHeight: { icon: 'fa-solid fa-arrow-up-right-dots' },
    index: { icon: 'fa-solid fa-hashtag' },
    coordinates: { icon: 'fa-solid fa-location-dot' },
    waylineCoordinateSysParam: { icon: 'fa-solid fa-map-location-dot' },
    globalWaypointHeadingParam: { icon: 'fa-solid fa-compass' },
    globalWaypointTurnMode: { icon: 'fa-solid fa-code-branch' },
    waypointHeadingParam: { icon: 'fa-solid fa-compass' },
    waypointTurnParam: { icon: 'fa-solid fa-arrows-turn-right' },
    gimbalPitchAngle: { icon: 'fa-solid fa-video' },
    waypointGimbalHeadingParam: { icon: 'fa-solid fa-video' },
    waypointGimbalPitchAngle: { icon: 'fa-solid fa-video' },
    waypointGimbalYawAngle: { icon: 'fa-solid fa-camera-rotate' },
    gimbalPitchMode: { icon: 'fa-solid fa-sliders' },
    waypointHeadingAngle: { icon: 'fa-solid fa-compass' },
    waypointHeadingAngleEnable: { icon: 'fa-solid fa-toggle-on' },
    waypointHeadingPoiIndex: { icon: 'fa-solid fa-bullseye' },
    waypointPoiPoint: { icon: 'fa-solid fa-location-crosshairs' },
    waypointTurnDampingDist: { icon: 'fa-solid fa-ruler' },
    waypointWorkType: { icon: 'fa-solid fa-briefcase' },
    templateType: { icon: 'fa-solid fa-file-code' },
    coordinateMode: { icon: 'fa-solid fa-globe' },
    positioningType: { icon: 'fa-solid fa-satellite' },
    caliFlightEnable: { icon: 'fa-solid fa-vial' },
    flyToWaylineMode: { icon: 'fa-solid fa-plane-arrival' },
    finishAction: { icon: 'fa-solid fa-flag-checkered' },
    exitOnRCLost: { icon: 'fa-solid fa-tower-broadcast' },
    executeRCLostAction: { icon: 'fa-solid fa-house-signal' },
    droneInfo: { icon: 'fa-solid fa-helicopter' },
    payloadEnumValue: { icon: 'fa-solid fa-camera' },
    payloadSubEnumValue: { icon: 'fa-solid fa-camera-retro' },
    waylineAvoidLimitAreaMode: { icon: 'fa-solid fa-ban' },
    payloadInfo: { icon: 'fa-solid fa-camera' },
    payloadParam: { icon: 'fa-solid fa-sliders' },
    meteringMode: { icon: 'fa-solid fa-lightbulb' },
    dewarpingEnable: { icon: 'fa-solid fa-bug' },
    returnMode: { icon: 'fa-solid fa-wave-square' },
    samplingRate: { icon: 'fa-solid fa-chart-line' },
    scanningMode: { icon: 'fa-solid fa-repeat' },
    modelColoringEnable: { icon: 'fa-solid fa-palette' },
    useGlobalHeight: { icon: 'fa-solid fa-layer-group' },
    useGlobalSpeed: { icon: 'fa-solid fa-gauge-high' },
    useGlobalHeadingParam: { icon: 'fa-solid fa-compass' },
    useGlobalTurnParam: { icon: 'fa-solid fa-bezier-curve' },
    useStraightLine: { icon: 'fa-solid fa-slash' },
    isRisky: { icon: 'fa-solid fa-triangle-exclamation' },
    autoFlightSpeed: { icon: 'fa-solid fa-gauge' },
    waypointSpeed: { icon: 'fa-solid fa-person-running' },
    waypointHeadingMode: { icon: 'fa-solid fa-location-arrow' },
    waypointTurnMode: { icon: 'fa-solid fa-arrows-turn-right' },
    takeOffSecurityHeight: { icon: 'fa-solid fa-shield-halved' },
    globalTransitionalSpeed: { icon: 'fa-solid fa-forward-fast' },
    payloadPositionIndex: { icon: 'fa-solid fa-camera' },
    droneEnumValue: { icon: 'fa-solid fa-helicopter' },
    droneSubEnumValue: { icon: 'fa-solid fa-helicopter-symbol' },
    missionConfig: { icon: 'fa-solid fa-sliders' },
    templateId: { icon: 'fa-solid fa-id-badge' },
    waylineId: { icon: 'fa-solid fa-diagram-project' },
    distance: { icon: 'fa-solid fa-ruler-horizontal' },
    duration: { icon: 'fa-regular fa-hourglass-half' }
  }
  const djiFieldDocs = PORTAL_PRESETS.docs.fields

  Object.keys(djiFieldDocs).forEach((field) => {
    const meta = djiFieldDocs[field] || {}
    if (!meta.tooltip) meta.tooltip = 'tooltip.' + field
    if (!meta.detail) meta.detail = 'explain.' + field
  })

  const fnAutoIconForField = function (field) {
    const f = String(field || '').toLowerCase()
    if (f.includes('time')) return 'fa-regular fa-clock'
    if (f.includes('height') || f.includes('altitude')) return 'fa-solid fa-ruler-vertical'
    if (f.includes('speed')) return 'fa-solid fa-gauge-high'
    if (f.includes('heading') || f.includes('yaw')) return 'fa-solid fa-compass'
    if (f.includes('gimbal')) return 'fa-solid fa-video'
    if (f.includes('template')) return 'fa-solid fa-file-code'
    if (f.includes('wayline')) return 'fa-solid fa-diagram-project'
    if (f.includes('coordinate') || f.includes('position')) return 'fa-solid fa-location-dot'
    if (f.includes('turn')) return 'fa-solid fa-arrows-turn-right'
    if (f.includes('risk')) return 'fa-solid fa-triangle-exclamation'
    if (f.includes('drone')) return 'fa-solid fa-helicopter'
    if (f.includes('payload') || f.includes('camera')) return 'fa-solid fa-camera'
    if (f.includes('mode')) return 'fa-solid fa-sliders'
    if (f.endsWith('id') || f.endsWith('index')) return 'fa-solid fa-hashtag'
    if (f.includes('distance')) return 'fa-solid fa-ruler-horizontal'
    if (f.includes('duration')) return 'fa-regular fa-hourglass-half'
    if (f.includes('work')) return 'fa-solid fa-briefcase'
    if (f.includes('straightline')) return 'fa-solid fa-slash'
    if (f.startsWith('is') || f.startsWith('use')) return 'fa-solid fa-toggle-on'
    return 'fa-solid fa-tag'
  }

  const fnEnsureFieldMeta = function (field, doc) {
    const key = String(field || '').trim()
    if (!key) return
    const meta = doc || {}
    if (!fieldTooltipsByField[key] && meta.tooltip) fieldTooltipsByField[key] = meta.tooltip
    if (!fieldHelpDetailsByField[key] && meta.detail) fieldHelpDetailsByField[key] = meta.detail
    if (!fieldIconsByField[key]) {
      fieldIconsByField[key] = meta.icon || fnAutoIconForField(key)
    }
  }

  PORTAL_PRESETS.actions.kmz = [
    {
      value: 'gimbalRotate',
      tooltip: 'kmz_action.tooltip.gimbal_rotate',
      defaultParams: {
        gimbalHeadingYawBase: 'north',
        gimbalRotateMode: 'absoluteAngle',
        gimbalPitchRotateEnable: '1',
        gimbalPitchRotateAngle: '0',
        gimbalRollRotateEnable: '0',
        gimbalRollRotateAngle: '0',
        gimbalYawRotateEnable: '0',
        gimbalYawRotateAngle: '0',
        gimbalRotateTimeEnable: '0',
        gimbalRotateTime: '0',
        payloadPositionIndex: '0'
      },
      paramMeta: {
        gimbalHeadingYawBase: { description: 'kmz_action.param.gimbalHeadingYawBase', enum: ['north', 'aircraft'] },
        gimbalRotateMode: { description: 'kmz_action.param.gimbalRotateMode', enum: ['absoluteAngle'] },
        gimbalPitchRotateEnable: { description: 'kmz_action.param.gimbalPitchRotateEnable', enum: ['0', '1'] },
        gimbalPitchRotateAngle: { description: 'kmz_action.param.gimbalPitchRotateAngle', min: -90, max: 0, type: 'number' },
        gimbalRollRotateEnable: { description: 'kmz_action.param.gimbalRollRotateEnable', enum: ['0', '1'] },
        gimbalRollRotateAngle: { description: 'kmz_action.param.gimbalRollRotateAngle', min: 0, type: 'number' },
        gimbalYawRotateEnable: { description: 'kmz_action.param.gimbalYawRotateEnable', enum: ['0', '1'] },
        gimbalYawRotateAngle: { description: 'kmz_action.param.gimbalYawRotateAngle', min: 0, max: 180, type: 'number' },
        gimbalRotateTimeEnable: { description: 'kmz_action.param.gimbalRotateTimeEnable', enum: ['0', '1'] },
        gimbalRotateTime: { description: 'kmz_action.param.gimbalRotateTime', min: 0, max: 10, type: 'number' },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] }
      }
    },
    {
      value: 'gimbalEvenlyRotate',
      tooltip: 'kmz_action.tooltip.gimbal_evenly_rotate',
      defaultParams: {
        gimbalPitchRotateAngle: '0',
        gimbalRollRotateAngle: '0',
        payloadPositionIndex: '0'
      },
      paramMeta: {
        gimbalPitchRotateAngle: { description: 'kmz_action.param.gimbalPitchRotateAngle', min: -90, max: 0, type: 'number' },
        gimbalRollRotateAngle: { description: 'kmz_action.param.gimbalRollRotateAngle', min: 0, type: 'number' },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] }
      }
    },
    {
      value: 'focus',
      tooltip: 'kmz_action.tooltip.focus',
      defaultParams: {
        focusX: '0.25',
        focusY: '0.25',
        focusRegionWidth: '0.5',
        focusRegionHeight: '0.5',
        isPointFocus: '0',
        isInfiniteFocus: '0',
        payloadPositionIndex: '0',
        isCalibrationFocus: '0'
      },
      paramMeta: {
        focusX: { description: 'kmz_action.param.focusX', min: 0, max: 1, type: 'number' },
        focusY: { description: 'kmz_action.param.focusY', min: 0, max: 1, type: 'number' },
        focusRegionWidth: { description: 'kmz_action.param.focusRegionWidth', min: 0, max: 1, type: 'number' },
        focusRegionHeight: { description: 'kmz_action.param.focusRegionHeight', min: 0, max: 1, type: 'number' },
        isPointFocus: { description: 'kmz_action.param.isPointFocus', enum: ['0', '1'] },
        isInfiniteFocus: { description: 'kmz_action.param.isInfiniteFocus', enum: ['0', '1'] },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] },
        isCalibrationFocus: { description: 'kmz_action.param.isCalibrationFocus', enum: ['0', '1'] }
      }
    },
    {
      value: 'takePhoto',
      tooltip: 'kmz_action.tooltip.take_photo',
      defaultParams: {
        fileSuffix: 'Waypoint',
        payloadPositionIndex: '0',
        useGlobalPayloadLensIndex: '1'
      },
      paramMeta: {
        fileSuffix: { description: 'kmz_action.param.fileSuffix' },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] },
        useGlobalPayloadLensIndex: { description: 'kmz_action.param.useGlobalPayloadLensIndex', enum: ['0', '1'] }
      }
    },
    {
      value: 'orientedShoot',
      tooltip: 'kmz_action.tooltip.oriented_shoot',
      defaultParams: {
        gimbalPitchRotateAngle: '0',
        gimbalRollRotateAngle: '0',
        gimbalYawRotateAngle: '0',
        focusX: '0',
        focusY: '0',
        focusRegionWidth: '0',
        focusRegionHeight: '0',
        focalLength: '24',
        aircraftHeading: '0',
        accurateFrameValid: '0',
        payloadPositionIndex: '0',
        useGlobalPayloadLensIndex: '1',
        targetAngle: '0',
        actionUUID: '00000000-0000-0000-0000-000000000000',
        imageWidth: '0',
        imageHeight: '0',
        AFPos: '0',
        gimbalPort: '0',
        orientedCameraType: '67',
        orientedFilePath: '00000000-0000-0000-0000-000000000000',
        orientedFileMD5: '',
        orientedFileSize: '0',
        orientedPhotoMode: 'normalPhoto'
      },
      paramMeta: {
        gimbalPitchRotateAngle: {
          description: 'kmz_action.param.gimbalPitchRotateAngle',
          min: -120,
          max: 45,
          type: 'number',
          droneRanges: {
            '67': { min: -120, max: 45, label: 'M30/M30T' },
            '77': { min: -90, max: 35, label: 'M3E/M3T' },
            '91': { min: -90, max: 30, label: 'M3D/M3TD' }
          }
        },
        gimbalRollRotateAngle: { description: 'kmz_action.param.gimbalRollRotateAngle', min: 0, type: 'number' },
        gimbalYawRotateAngle: { description: 'kmz_action.param.gimbalYawRotateAngle', min: -180, max: 180, type: 'number' },
        focusX: { description: 'kmz_action.param.focusX', min: 0, max: 1, type: 'number' },
        focusY: { description: 'kmz_action.param.focusY', min: 0, max: 1, type: 'number' },
        focusRegionWidth: { description: 'kmz_action.param.focusRegionWidth', min: 0, max: 1, type: 'number' },
        focusRegionHeight: { description: 'kmz_action.param.focusRegionHeight', min: 0, max: 1, type: 'number' },
        focalLength: { description: 'kmz_action.param.focalLength', min: 24, max: 1344, type: 'number' },
        aircraftHeading: { description: 'kmz_action.param.aircraftHeading', min: -180, max: 180, type: 'number' },
        accurateFrameValid: { description: 'kmz_action.param.accurateFrameValid', enum: ['0', '1'] },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0'] },
        useGlobalPayloadLensIndex: { description: 'kmz_action.param.useGlobalPayloadLensIndex', enum: ['0', '1'] },
        targetAngle: { description: 'kmz_action.param.targetAngle', min: 0, type: 'number' },
        actionUUID: { description: 'kmz_action.param.actionUUID' },
        imageWidth: { description: 'kmz_action.param.imageWidth', min: 0, type: 'number' },
        imageHeight: { description: 'kmz_action.param.imageHeight', min: 0, type: 'number' },
        AFPos: { description: 'kmz_action.param.AFPos', min: 0, type: 'number' },
        gimbalPort: { description: 'kmz_action.param.gimbalPort', min: 0, type: 'number' },
        orientedCameraType: { description: 'kmz_action.param.orientedCameraType', enum: ['52', '53', '66', '67', '80', '81'] },
        orientedFilePath: { description: 'kmz_action.param.orientedFilePath' },
        orientedFileMD5: { description: 'kmz_action.param.orientedFileMD5' },
        orientedFileSize: { description: 'kmz_action.param.orientedFileSize', min: 0, type: 'number' },
        orientedPhotoMode: { description: 'kmz_action.param.orientedPhotoMode', enum: ['normalPhoto', 'lowLightSmartShooting'] }
      }
    },
    {
      value: 'startRecord',
      tooltip: 'kmz_action.tooltip.start_record',
      defaultParams: {
        fileSuffix: 'Waypoint',
        payloadPositionIndex: '0',
        useGlobalPayloadLensIndex: '1'
      },
      paramMeta: {
        fileSuffix: { description: 'kmz_action.param.fileSuffix' },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] },
        useGlobalPayloadLensIndex: { description: 'kmz_action.param.useGlobalPayloadLensIndex', enum: ['0', '1'] }
      }
    },
    {
      value: 'stopRecord',
      tooltip: 'kmz_action.tooltip.stop_record',
      defaultParams: {
        payloadPositionIndex: '0'
      },
      paramMeta: {
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] }
      }
    },
    {
      value: 'zoom',
      tooltip: 'kmz_action.tooltip.zoom',
      defaultParams: {
        focalLength: '24',
        isUseFocalFactor: '0',
        payloadPositionIndex: '0'
      },
      paramMeta: {
        focalLength: { description: 'kmz_action.param.focalLength', min: 24, max: 1344, type: 'number' },
        isUseFocalFactor: { description: 'kmz_action.param.isUseFocalFactor', enum: ['0', '1'] },
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] }
      }
    },
    {
      value: 'customDirName',
      tooltip: 'kmz_action.tooltip.custom_dir_name',
      defaultParams: {
        payloadPositionIndex: '0'
      },
      paramMeta: {
        payloadPositionIndex: { description: 'kmz_action.param.payloadPositionIndex', enum: ['0', '1', '2'] }
      }
    },
    {
      value: 'hover',
      tooltip: 'kmz_action.tooltip.hover',
      defaultParams: {
        hoverTime: '1'
      },
      paramMeta: {
        hoverTime: { description: 'kmz_action.param.hoverTime', min: 1, type: 'number' }
      }
    },
    {
      value: 'rotateYaw',
      tooltip: 'kmz_action.tooltip.rotate_yaw',
      defaultParams: {
        aircraftHeading: '0',
        aircraftPathMode: 'counterClockwise'
      },
      paramMeta: {
        aircraftHeading: { description: 'kmz_action.param.aircraftHeading', min: -180, max: 180, type: 'number' },
        aircraftPathMode: { description: 'kmz_action.param.aircraftPathMode', enum: ['clockwise', 'counterClockwise'] }
      }
    }
  ]

  const kmzActionPresets = PORTAL_PRESETS.actions.kmz

  /*
   * KMZ export truth table (source: sample18).
   * Full explicit matrix: every action and every parameter key is listed.
   * Scope meaning:
   * template=1, waylines=0 -> template.kml only
   * template=0, waylines=1 -> waylines.wpml only
   * template=1, waylines=1 -> both
   * template=0, waylines=0 -> neither
   */
  PORTAL_PRESETS.actions.kmzExportTruthTable = {
  source: "sample18_compact_full_matrix",
  unknownActionScope: {
    template: 1,
    waylines: 1
  },
  unknownParamScope: {
    template: 1,
    waylines: 1
  },
  actionScopes: {
    accurateShoot: {
      template: 0,
      waylines: 0
    },
    customDirName: {
      template: 1,
      waylines: 1
    },
    focus: {
      template: 0,
      waylines: 1
    },
    gimbalEvenlyRotate: {
      template: 0,
      waylines: 1
    },
    gimbalRotate: {
      template: 1,
      waylines: 1
    },
    hover: {
      template: 1,
      waylines: 1
    },
    orientedShoot: {
      template: 1,
      waylines: 1
    },
    panoShot: {
      template: 0,
      waylines: 0
    },
    recordPointCloud: {
      template: 0,
      waylines: 0
    },
    rotateYaw: {
      template: 1,
      waylines: 1
    },
    startRecord: {
      template: 1,
      waylines: 1
    },
    stopRecord: {
      template: 1,
      waylines: 1
    },
    takePhoto: {
      template: 1,
      waylines: 1
    },
    zoom: {
      template: 1,
      waylines: 1
    }
  },
  paramScopes: {
    accurateShoot: {
      accurateCameraApertue: {
        template: 0,
        waylines: 0
      },
      accurateCameraISO: {
        template: 0,
        waylines: 0
      },
      accurateCameraLuminance: {
        template: 0,
        waylines: 0
      },
      accurateCameraShutterTime: {
        template: 0,
        waylines: 0
      },
      accurateCameraType: {
        template: 0,
        waylines: 0
      },
      accurateFileMD5: {
        template: 0,
        waylines: 0
      },
      accurateFilePath: {
        template: 0,
        waylines: 0
      },
      accurateFileSize: {
        template: 0,
        waylines: 0
      },
      accurateFileSuffix: {
        template: 0,
        waylines: 0
      },
      accurateFrameValid: {
        template: 0,
        waylines: 0
      },
      AFPos: {
        template: 0,
        waylines: 0
      },
      aircraftHeading: {
        template: 0,
        waylines: 0
      },
      focalLength: {
        template: 0,
        waylines: 0
      },
      focusRegionHeight: {
        template: 0,
        waylines: 0
      },
      focusRegionWidth: {
        template: 0,
        waylines: 0
      },
      focusX: {
        template: 0,
        waylines: 0
      },
      focusY: {
        template: 0,
        waylines: 0
      },
      gimbalPitchRotateAngle: {
        template: 0,
        waylines: 0
      },
      gimbalPort: {
        template: 0,
        waylines: 0
      },
      gimbalYawRotateAngle: {
        template: 0,
        waylines: 0
      },
      imageHeight: {
        template: 0,
        waylines: 0
      },
      imageWidth: {
        template: 0,
        waylines: 0
      },
      payloadLensIndex: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 0,
        waylines: 0
      },
      targetAngle: {
        template: 0,
        waylines: 0
      },
      useGlobalPayloadLensIndex: {
        template: 0,
        waylines: 0
      }
    },
    customDirName: {
      directoryName: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      }
    },
    focus: {
      focusRegionHeight: {
        template: 0,
        waylines: 1
      },
      focusRegionWidth: {
        template: 0,
        waylines: 1
      },
      focusX: {
        template: 0,
        waylines: 1
      },
      focusY: {
        template: 0,
        waylines: 1
      },
      isInfiniteFocus: {
        template: 0,
        waylines: 1
      },
      isPointFocus: {
        template: 0,
        waylines: 1
      },
      isCalibrationFocus: {
        template: 0,
        waylines: 1
      },
      payloadPositionIndex: {
        template: 0,
        waylines: 1
      }
    },
    gimbalEvenlyRotate: {
      gimbalPitchRotateAngle: {
        template: 0,
        waylines: 1
      },
      gimbalRollRotateAngle: {
        template: 0,
        waylines: 1
      },
      payloadPositionIndex: {
        template: 0,
        waylines: 1
      }
    },
    gimbalRotate: {
      gimbalHeadingYawBase: {
        template: 0,
        waylines: 1
      },
      gimbalPitchRotateAngle: {
        template: 1,
        waylines: 1
      },
      gimbalPitchRotateEnable: {
        template: 1,
        waylines: 1
      },
      gimbalRollRotateAngle: {
        template: 1,
        waylines: 1
      },
      gimbalRollRotateEnable: {
        template: 1,
        waylines: 1
      },
      gimbalRotateMode: {
        template: 1,
        waylines: 1
      },
      gimbalRotateTime: {
        template: 1,
        waylines: 1
      },
      gimbalRotateTimeEnable: {
        template: 1,
        waylines: 1
      },
      gimbalYawRotateAngle: {
        template: 1,
        waylines: 1
      },
      gimbalYawRotateEnable: {
        template: 1,
        waylines: 1
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      }
    },
    hover: {
      hoverTime: {
        template: 1,
        waylines: 1
      }
    },
    orientedShoot: {
      accurateFrameValid: {
        template: 1,
        waylines: 1
      },
      actionUUID: {
        template: 1,
        waylines: 1
      },
      AFPos: {
        template: 1,
        waylines: 1
      },
      aircraftHeading: {
        template: 1,
        waylines: 1
      },
      focalLength: {
        template: 1,
        waylines: 1
      },
      focusRegionHeight: {
        template: 1,
        waylines: 1
      },
      focusRegionWidth: {
        template: 1,
        waylines: 1
      },
      focusX: {
        template: 1,
        waylines: 1
      },
      focusY: {
        template: 1,
        waylines: 1
      },
      gimbalPitchRotateAngle: {
        template: 1,
        waylines: 1
      },
      gimbalRollRotateAngle: {
        template: 1,
        waylines: 1
      },
      gimbalPort: {
        template: 1,
        waylines: 1
      },
      gimbalYawRotateAngle: {
        template: 1,
        waylines: 1
      },
      imageHeight: {
        template: 1,
        waylines: 1
      },
      imageWidth: {
        template: 1,
        waylines: 1
      },
      orientedCameraApertue: {
        template: 0,
        waylines: 0
      },
      orientedCameraISO: {
        template: 0,
        waylines: 0
      },
      orientedCameraLuminance: {
        template: 0,
        waylines: 0
      },
      orientedCameraShutterTime: {
        template: 0,
        waylines: 0
      },
      orientedCameraType: {
        template: 1,
        waylines: 1
      },
      orientedFileMD5: {
        template: 1,
        waylines: 1
      },
      orientedFilePath: {
        template: 1,
        waylines: 1
      },
      orientedFileSize: {
        template: 1,
        waylines: 1
      },
      orientedFileSuffix: {
        template: 0,
        waylines: 0
      },
      orientedPhotoMode: {
        template: 1,
        waylines: 1
      },
      payloadLensIndex: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      },
      targetAngle: {
        template: 1,
        waylines: 1
      },
      useGlobalPayloadLensIndex: {
        template: 1,
        waylines: 1
      }
    },
    panoShot: {
      panoShotSubMode: {
        template: 0,
        waylines: 0
      },
      payloadLensIndex: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 0,
        waylines: 0
      },
      useGlobalPayloadLensIndex: {
        template: 0,
        waylines: 0
      }
    },
    recordPointCloud: {
      payloadPositionIndex: {
        template: 0,
        waylines: 0
      },
      recordPointCloudOperate: {
        template: 0,
        waylines: 0
      }
    },
    rotateYaw: {
      aircraftHeading: {
        template: 1,
        waylines: 1
      },
      aircraftPathMode: {
        template: 1,
        waylines: 1
      }
    },
    startRecord: {
      fileSuffix: {
        template: 1,
        waylines: 1
      },
      payloadLensIndex: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      },
      useGlobalPayloadLensIndex: {
        template: 1,
        waylines: 1
      }
    },
    stopRecord: {
      payloadLensIndex: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      }
    },
    takePhoto: {
      fileSuffix: {
        template: 1,
        waylines: 1
      },
      payloadLensIndex: {
        template: 0,
        waylines: 0
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      },
      useGlobalPayloadLensIndex: {
        template: 1,
        waylines: 1
      }
    },
    zoom: {
      focalLength: {
        template: 1,
        waylines: 1
      },
      isUseFocalFactor: {
        template: 1,
        waylines: 1
      },
      payloadPositionIndex: {
        template: 1,
        waylines: 1
      }
    }
  }
}

  PORTAL_PRESETS.altitudeRules = {
    modeAliases: {
      EGM96: ['EGM96', 'ASL', 'MSL'],
      WGS84: ['WGS84', 'ELLIPSOID'],
      relativeToStartPoint: ['RELATIVETOSTARTPOINT', 'RELATIVE_TO_START_POINT', 'RELATIVE'],
      realTimeFollowSurface: ['REALTIMEFOLLOWSURFACE', 'AGL']
    },
    templateModeReference: {
      EGM96: 'geoidLike',
      WGS84: 'absoluteEllipsoid',
      relativeToStartPoint: 'relativeToStartPoint',
      realTimeFollowSurface: 'relativeToSurface'
    },
    executeModeReference: {
      WGS84: 'absoluteEllipsoid',
      relativeToStartPoint: 'relativeToStartPoint',
      realTimeFollowSurface: 'relativeToSurface'
    },
    egm96FallbackDefaultOffset: 43.0,
    egm96HungaryFallbackGrid: [
      { lonMin: 16.0, lonMax: 18.3, latMin: 45.6, latMax: 47.2, offset: 45.347 },
      { lonMin: 18.3, lonMax: 20.6, latMin: 45.6, latMax: 47.2, offset: 43.803 },
      { lonMin: 20.6, lonMax: 23.0, latMin: 45.6, latMax: 47.2, offset: 42.238 },
      { lonMin: 16.0, lonMax: 18.3, latMin: 47.2, latMax: 48.8, offset: 44.317 },
      { lonMin: 18.3, lonMax: 20.6, latMin: 47.2, latMax: 48.8, offset: 43.310 },
      { lonMin: 20.6, lonMax: 23.0, latMin: 47.2, latMax: 48.8, offset: 40.450 }
    ],
    sourcePriority: ['executeHeight', 'globalOrPointHeight', 'ellipsoidHeight', 'coordinateAlt', 'xmlFallback']
  }
  const altitudeRules = PORTAL_PRESETS.altitudeRules

  valueHelpByField.heightMode = {
    relativeToStartPoint: 'value_help.height_mode.relative_to_start_point',
    EGM96: 'value_help.height_mode.egm96',
    WGS84: 'value_help.height_mode.wgs84',
    realTimeFollowSurface: 'value_help.height_mode.real_time_follow_surface'
  }
  valueHelpByField.executeHeightMode = Object.assign({}, valueHelpByField.heightMode)
  valueHelpByField.altitudeMode = {
    absolute: 'value_help.altitude_mode.absolute',
    relativeToGround: 'value_help.altitude_mode.relative_to_ground',
    clampToGround: 'value_help.altitude_mode.clamp_to_ground'
  }
  valueHelpByField.droneEnumValue = {
    '60': 'M300 RTK',
    '67': 'M30/M30T',
    '77': 'M3E/M3T/M3M',
    '89': 'M350 RTK',
    '91': 'M3D/M3TD'
  }
  valueHelpByField.droneSubEnumValue = {
    '0': 'value_help.drone_sub.0',
    '1': 'value_help.drone_sub.1',
    '2': 'value_help.drone_sub.2'
  }

  Object.keys(djiFieldDocs).forEach((field) => {
    fnEnsureFieldMeta(field, djiFieldDocs[field])
  })
  Object.keys(valuePresetsByField).forEach((field) => {
    fnEnsureFieldMeta(field, djiFieldDocs[field])
  })
  kmzActionPresets.forEach((preset) => {
    const metaMap = (preset && preset.paramMeta && typeof preset.paramMeta === 'object') ? preset.paramMeta : {}
    Object.keys(metaMap).forEach((field) => {
      const info = metaMap[field] || {}
      fnEnsureFieldMeta(field, {
        tooltip: info.description || '',
        detail: info.description || '',
        icon: fnAutoIconForField(field)
      })
    })
  })

if (typeof window !== 'undefined') {
  window.PORTAL_PRESETS = PORTAL_PRESETS
}

export {
  PORTAL_PRESETS,
  resolvePortalPresetDefaultValue,
  applyPortalPresetDefaultsToFlatMap
}
